import '../assets/style/NotFound.scss';

const NotFound = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">

        <h1 className="error-code">404</h1>

        <h2 className="error-title">
          Page Not Found
        </h2>

        <p className="error-description">
          The page you're looking for doesn't exist or has been moved.
          Please check the URL or return to the homepage.
        </p>

        <div className="button-group">
          <button
            className="primary-btn"
            onClick={() => (window.location.href = '/loginmpin')}
          >
            Go Home
          </button>

        </div>

      </div>

      <div className="illustration-container">
        <div className="circle-bg" />
        <div className="floating-card">
          <span>🚀</span>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
